import { CSSProperties } from "react";
import {
  SIDEBAR_WIDTHS,
  colors,
  sidebarTokens,
  type SidebarWidth,
} from "@libertify/ui";

export const MOBILE_HEADER_HEIGHT = 56;

// The app sidebar's `<Sidebar width>` preset. Layouts that offset content by
// the sidebar (fixed footers / toolbars) read the widths below.
export const SIDER_PRESET: SidebarWidth = "default";
export const SIDER_WIDTH = SIDEBAR_WIDTHS[SIDER_PRESET].expanded;
export const SIDER_COLLAPSED_WIDTH = SIDEBAR_WIDTHS[SIDER_PRESET].collapsed;

// Sidebar text + icon color (brand ink).
export const NAV_TEXT_COLOR = colors.secondary[700];

export const sidebarMenuItemStyle: CSSProperties = {
  justifyContent: "start",
  gap: 12,
  height: 44,
  padding: "0 24px",
  ...sidebarTokens.itemFont,
  fontWeight: 400,
  borderRadius: 10,
  color: NAV_TEXT_COLOR,
};

export const antLayoutSider: CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
};
export const antLayoutSiderMobile: CSSProperties = {
  position: "fixed",
  top: MOBILE_HEADER_HEIGHT,
  left: 0,
  height: `calc(100vh - ${MOBILE_HEADER_HEIGHT}px)`,
  zIndex: 999,
};
